import { isNumber } from "lodash";

import type { Order } from "../../../../../../../services";
import type { DateFns } from "../../../../../../../utils/DateFns";

const cellProcessing = (item: Order.Model, dateFns: DateFns): string => {
	const executorArrivalTimestamp =
		item?.executorToOrder?.[0]?.additionalFields?.arrivalTime ||
		item?.additionalFields?.transfer?.lastReceivedOrder
			?.executorToOrder?.[0]?.additionalFields?.arrivalTime;

	const time =
		item?.orderDate ||
		item?.filledAt ||
		item?.additionalFields?.transfer?.lastReceivedOrder?.filledAt ||
		item?.additionalFields?.transfer?.lastReceivedOrder?.orderDate ||
		1;

	const orderTime = new Date(time).getTime();

	if (!isNumber(executorArrivalTimestamp)) return "";

	return dateFns.formatTime2(
		Math.max(orderTime, executorArrivalTimestamp),
		"HH:mm:ss",
		{
			zeroSeconds: true,
		},
	);
};

export default cellProcessing;
